import XLSX from 'xlsx';
import { downloadify } from '@bingads-webui/download-service';

const getDateString = () => new Date().toISOString().split('T')[0];

const getFileName = (id, extension) => {
  const dateString = getDateString();
  return `Lift_Experiment_Result_${id}_${dateString}.${extension}`;
};

const addWorksheet = (results, workbook, sheetName) => {
  if (results && results.length > 0) {
    const worksheet = XLSX.utils.json_to_sheet(results);
    XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);
  }
};

export const downloadExcel = (id, data) => {
  const workbook = XLSX.utils.book_new();
  const fileName = getFileName(id, 'xlsx');

  addWorksheet(data.Campaign_Result, workbook, 'CampaignResult');
  addWorksheet(data.CID_Result, workbook, 'CIDResult');
  addWorksheet(data.TargetType_Result, workbook, 'TargetTypeResult');
  addWorksheet(data.Top5_Result, workbook, 'Top5Result');
  addWorksheet(data.Bottom5_Result, workbook, 'Bottom5Result');

  XLSX.writeFile(workbook, fileName);

  return true;
};

export const downloadJson = (id, data) => {
  const fileName = getFileName(id, 'json');
  const dataString = JSON.stringify(data);
  downloadify(fileName, dataString, { type: 'text/json' });

  return true;
};
